import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class SkuMapping
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

  mappings(callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.private}`, callback)
  }

  mappingsBySupplier(supplierId, callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.supplier}/${supplierId}`, callback)
  }

  mapping(id, callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.private}/${id}`, callback)
  }

  removeByIdMapping(id, callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.private}/dependencies/${id}`, callback, 'DELETE')
  }

  add(data, callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.private}`, callback, 'POST', data)
  }

  remove(id, callback)
  {
    this.backend.callBackend(`${Endpoints.skuMapping.private}/${id}`, callback, 'DELETE')
  }

  edit (data, callback) {
    this.backend.callBackend(`${Endpoints.skuMapping.private}`, callback, 'PATCH', data)
  }
}